import type { BuilderConfig } from '@/types/builder';
import { TimelineDirection, TimelineSide, milestones } from './Timeline.types';
import Timeline from './Timeline.vue';

export const timelineInputs = [
    {
        name: 'events',
        description: 'The events to display in the timeline.',
        type: 'list',
        required: true,
        subFields: [
            {
                name: 'title',
                helperText: 'Will display the date if left empty.',
                type: 'string',
            },
            {
                name: 'text',
                helperText: 'The text of the event.',
                type: 'string',
                required: true,
            },
            {
                name: 'date',
                type: 'date',
                required: true,
            },
            {
                name: 'side',
                helperText: 'The side of the event in horizontal mode.',
                type: 'enum',
                required: true,
                enum: Object.values(TimelineSide),
            },
            {
                name: 'offset',
                helperText: 'Offset to the previous event in px. If left empty, the distance between dates is used.',
                type: 'number',
            },
            {
                name: 'breakStack',
                helperText: 'Whether the event should break into a new stack in horizontal mode.',
                type: 'boolean',
                defaultValue: false,
            },
        ],
        defaultValue: milestones,
    },
    {
        name: 'max',
        helperText: 'The maximum scroll distance of the timeline in px.',
        type: 'number',
        required: true,
    },
    {
        name: 'eventWidth',
        helperText: 'The width of the events in px.',
        type: 'number',
    },
    {
        name: 'stackGap',
        helperText: 'The gap between the events in px.',
        type: 'number',
    },
];

export default {
    component: Timeline,
    inputs: [
        ...timelineInputs,
        {
            name: 'direction',
            helperText: 'The direction of the timeline.',
            type: 'enum',
            enum: Object.values(TimelineDirection),
        },
        {
            name: 'max',
            helperText: 'The maximum progress of the timeline.',
            type: 'number',
            required: true,
        },
        {
            name: 'current',
            helperText: 'The current progress of the timeline based on `max`.',
            type: 'number',
        },
    ],
} satisfies BuilderConfig;
